import api from './api';

const billingService = {
  async createCheckoutSession(interval, planId = 'pro') {
    const response = await api.post('/api/billing/checkout-session', { interval, plan_id: planId });
    return response.data;
  },
  async createPortalSession() {
    const response = await api.post('/api/billing/portal', {});
    return response.data;
  },
  async fetchBillingStatus() {
    const response = await api.get('/api/billing/status');
    return response.data;
  },
  async confirmCheckoutSession(sessionId) {
    const response = await api.post('/api/billing/confirm-session', { session_id: sessionId });
    return response.data;
  },
};

export default billingService;
